<template>
    <div>
        <!-- show chart -->
        <app-chart :datasets="datasets"></app-chart>

        <div class="container-fluid">
            <div class="row">
                <div class="col-12 mt-5">
                    <p class="ml-3"><i class="fas fa-square-full text-dark-green"></i> New Shoppers</p>
                    <p class="ml-3"><i class="fas fa-square-full text-warning"></i> Re-visiting Shoppers</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Chart from './Chart.vue'

export default {
    name: "Shoppers",
    data() {
        return {
            datasets: [
                {
                    data: [70, 100, 400, 180, 100, 300, 500],
                    smooth: true,
                    showPoints: true,
                    fill: true,
                    className: "curve1"
                },
                {
                    data: [150, 300, 350, 100, 350, 100, 15],
                    smooth: true,
                    showPoints: true,
                    className: "curve2"
                }
            ]
        }
    },
    components: {
        appChart: Chart
    }
}
</script>